import * as React from 'react';
import { observer } from 'mobx-react';
import { observable, makeObservable } from 'mobx';
import compassImg from '../../../../../../foundations/tokens/src/icons/map-compass.svg';
import OlMap from 'ol/Map';

@observer
export class MapRotate extends React.Component<
    {
        mapInstance?: OlMap;
    },
    {}
> {
    startX = null;
    startRotation = null;

    @observable rotation = this.getCurrentRotation();

    constructor(props: { mapInstance?: OlMap }) {
        super(props);
        makeObservable(this);
    }

    componentDidMount(): void {
        this.props.mapInstance.getView().on('change:rotation', () => {
            this.rotation = this.getCurrentRotation();
        });
    }

    render() {
        return (
            <img
                src={compassImg}
                className='no-select'
                draggable={false}
                onDragStart={this.onDragStart}
                onMouseDown={this.onMouseDown}
                style={{
                    cursor: 'w-resize',
                    transform: `rotate(${this.rotation}deg)`,
                }}
            />
        );
    }

    onDragStart = e => e.preventDefault();

    onMouseDown = e => {
        window.addEventListener('mousemove', this.drag);
        window.addEventListener('mouseup', this.dragEnd);
        document.body.style.cursor = 'w-resize';
        this.startX = e.screenX;
        this.startRotation = this.getCurrentRotation();
    };

    drag = e => {
        const delta = (this.startX - e.screenX) * -1;
        this.props.mapInstance.getView().setRotation(((this.startRotation + (delta % 360)) * Math.PI) / 180);
    };

    dragEnd = e => {
        window.removeEventListener('mousemove', this.drag);
        window.removeEventListener('mouseup', this.dragEnd);
        document.body.style.cursor = 'default';

        const delta = (this.startX - e.screenX) * -1;
        if (Math.abs(delta) < 2) {
            this.props.mapInstance.getView().setRotation(0);
        }
    };

    public getCurrentRotation(): number {
        return (this.props.mapInstance.getView().getRotation() * 180) / Math.PI;
    }
}
